import React from 'react';
import { Button } from 'components/shared';
import { ReactSVG } from 'react-svg';
import closeIcon from 'assets/images/training/close-icon.svg';

import { Modal, Container, Content, Close } from './styles';

interface Props {
  isOpen: boolean;
  onRequestClose(): void;
  type?: 'success' | 'error';
  title?: string;
  message: string;
}

const MessageChangePasswordModal: React.FC<Props> = ({
  isOpen,
  onRequestClose,
  type = 'success',
  title,
  message,
}) => {
  return (
    <>
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} type={type === 'error' ? 'secondary' : 'primary'}>
      <Container>
        <Close>
          <button type="button" onClick={onRequestClose}>
            <ReactSVG src={closeIcon} />
          </button>
        </Close>
        <Content>
          <h3>{title || (type === 'error' ? 'Atenção' : 'Parabéns!')}</h3>
          <p className="message-text">{message}</p>
          <Button
            type="button"
            buttonRole="quaternary"
            onClick={onRequestClose}
          >
            Ok
          </Button>
        </Content>
      </Container>
    </Modal>
    </>
  );
};

export default MessageChangePasswordModal;